import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_18: FaireProductEntity = {
  token: "driftless-studios-18",
  type: "product",
  name: "12 Oz I Tried To Retire Wine Tumbler - Retirement Gifts",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/22f041aaee73d90b491b9a5079f96484271f3b319f5cb9ab2fc1e2ba87b0384b.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
